import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';

const DragAndDropImageUploader = (props) => {
	const [files, setFiles] = useState([]);

	const { handleForm } = props;

	const handleFile = useCallback(
		(file) => {
			if (
				!file ||
				(!file.name.toLowerCase().includes('png') &&
					!file.name.toLowerCase().includes('jpg') &&
					!file.name.toLowerCase().includes('jpeg'))
			) {
				// eslint-disable-next-line no-alert
				return alert(
					'Please upload a PNG or JPG image file smaller than 1 MB.'
				);
			}

			const formData = new FormData();
			formData.append('file', file);

			return handleForm(formData);
		},
		[handleForm]
	);

	const onDrop = useCallback(
		(newFiles) => {
			try {
				if (newFiles && newFiles.length) {
					const previewFiles = newFiles.map((file) =>
						Object.assign(file, {
							preview: URL.createObjectURL(file),
						})
					);
					setFiles(previewFiles);
					handleFile(previewFiles[0]);
				}
			} catch (err) {
				console.log('Error submitting form', err);
			}
		},
		[handleFile]
	);

	const removeFile = (event) => {
		event.stopPropagation();
		setFiles([]);
		props.resetTemplateImageUrl();
	};

	// display selected file name to user
	const getFileNames = () => {
		if (!files || files.length === 0) return props.uploadMessage;

		const fileNames = files.map((file) => file.name);

		return `Selected image: ${fileNames.join('')}`;
	};

	const { getRootProps, getInputProps } = useDropzone({
		onDrop,
		disabled: props.disabled,
		accept: 'image/*',
		multiple: false,
		maxFiles: 1,
		maxSize: 4999999,
		onDropRejected: () =>
			alert(
				'Please ensure to select an image smaller than 5MB (Five megabytes)'
			),
	});

	const renderDropzone = () => (
		<div
			style={{
				paddingTop: 4,
				paddingBottom: 4,
				width: '100%',
				cursor: props.disabled ? 'not-allowed' : 'pointer',
			}}
			className={`rounded-lg border border-dashed max-md:flex max-md:min-h-11 max-md:items-center ${
				props.disabled
					? 'border-border/50 text-muted-foreground'
					: 'border-muted-foreground'
			}`}
		>
			<input {...getInputProps()} disabled={props.disabled} />
			<p style={{ padding: '8px', fontSize: '13px' }}>{getFileNames()}</p>
		</div>
	);

	return (
		<div
			{...getRootProps()}
			style={{
				display: 'flex',
				flexDirection: 'row',
				flexWrap: 'no-wrap',
				justifyContent: 'space-between',
				marginTop: 10,
				cursor: 'pointer',
			}}
		>
			{renderDropzone()}
			{files.length > 0 && (
				<button
					className="ml-1 max-md:min-h-11 max-md:px-3"
					onClick={(event) => removeFile(event)}
				>
					Remove
				</button>
			)}

			<div style={{ color: 'red' }}>{props.dialogError}</div>
		</div>
	);
};

DragAndDropImageUploader.propTypes = {
	uploadMessage: PropTypes.string,
	allowMultipleFiles: PropTypes.bool,
};

DragAndDropImageUploader.defaultProps = {
	allowMultipleFiles: false,
	uploadMessage: 'Optional - Drag an image here or click to select an image.',
};

export default DragAndDropImageUploader;
